import { Signal } from '@angular/core';
import { ContactPoint } from './contact-point.app';
import { InstitutionBranchItem } from './institution.app';

export interface SearchQuery {
	clientId?: number;
	offset?: number;
	range?: number;
	searchClients: boolean;
	searchUsers: boolean;
	searchClientEnvironments: boolean;
	searchInstitutions: boolean;
	searchInstitutionBranches: boolean;
	searchInstitutionPerson: boolean;
	searchSponsors: boolean;
	searchIso: boolean;
	searchSponsorPerson?: boolean;
	searchAssignments?: boolean;
	searchTerm?: string;
	includeContactPoints?: boolean;
}

export interface SearchResultItem {
	item: {
		id: number;
		objectId: string;
		name: string;
		firstName?: string;
		institutionName?: string;
		dateOfBirth?: string;
		remark?: string;
		consultant?: {
			name: string;
		};
		address?: {
			street?: string;
			housenumber?: string;
			postalCode?: string;
			location?: string;
		};
		institution?: {
			id: number;
			name: string;
			industryName: string;
		};
		archiveId?: number;
		isArchived?: boolean;
		institutionId?: number;
		isMainInstitution?: boolean;
		user?: {
			id?: number | string;
			firstName?: string;
			name?: string;
		};
		sponsor?: {
			id: number;
			name: string;
		};
		integrationServiceOfficeId?: number;
		integrationServiceOffice?: {
			id: number;
			remark: string;
			shortName: string;
		};
		institutionPersonInstitutionBranches?: {
			id: number;
			institutionBranch: {
				id: number;
				name: string;
			};
		}[];
		role?: string;
		specialisation?: string;

		// For search results of type Assignment
		clientId?: number;
		guid?: string;
		ownerOfAdditionalAssignment?: {
			id?: number | string;
			firstName?: string;
			name?: string;
		};
		isServiceOfficeStatement?: boolean;
		isAdditionalAssignment?: boolean;
		phaseId?: number;
		draftPhaseId?: number;
		categoryTypeOfCare?: {
			id: number;
			remark: string;
			initial: string;
		};
	};
	personType: PERSON_TYPE;
	ableToRepresentAs?: number | string | null;
	isInYourIntegrationServiceOffice?: boolean;
	contactPoints?: ContactPoint[];
	institutionBranch?: InstitutionBranchItem;
}

export type SearchScope = 'institutions' | 'clients' | 'users' | 'sponsors' | 'isos' | 'assignments';

export type ToggleSearchScope = SearchScope | 'clientEnvironments' | 'institutionPersons';

export interface SearchFilterOption {
	scope: SearchScope;
	labelKey: string;
	checked: Signal<boolean>;
}

export enum PERSON_TYPE {
	UNKNOWN = 0,
	CLIENT = 1,
	USER = 2,
	RELATIVES = 3,
	BIH = 4,
	SERVICE = 5,
	INSTITUTION = 6,
	INSTITUTION_PERSON = 7,
	INTEGRATION_OFFICER = 8,
	SPONSOR = 9,
	WITHOUT_SPONSOR = 10,
	SPONSOR_CONTACT_PERSON = 11,
	ASSIGNMENT = 12,
	INSTITUTION_BRANCH = 13,
	INTEGRATION_SERVICE_OFFICE = 14,
}

export const personTypeTranslationKeys: Record<PERSON_TYPE, string> = {
	[PERSON_TYPE.UNKNOWN]: 'personType.unknown',
	[PERSON_TYPE.CLIENT]: 'personType.client',
	[PERSON_TYPE.USER]: 'personType.user',
	[PERSON_TYPE.RELATIVES]: 'personType.relatives',
	[PERSON_TYPE.BIH]: 'personType.bih',
	[PERSON_TYPE.SERVICE]: 'personType.service',
	[PERSON_TYPE.INSTITUTION]: 'personType.institution',
	[PERSON_TYPE.INSTITUTION_PERSON]: 'personType.institution_person',
	[PERSON_TYPE.INTEGRATION_OFFICER]: 'personType.integration_officer',
	[PERSON_TYPE.SPONSOR]: 'personType.sponsor',
	[PERSON_TYPE.WITHOUT_SPONSOR]: 'personType.without_sponsor',
	[PERSON_TYPE.SPONSOR_CONTACT_PERSON]: 'personType.sponsor_contact_person',
	[PERSON_TYPE.INSTITUTION_BRANCH]: 'personType.institution_branch',
	[PERSON_TYPE.INTEGRATION_SERVICE_OFFICE]: 'personType.institution_service_office',
	[PERSON_TYPE.ASSIGNMENT]: 'personType.assignment',
};
